import { FC } from 'react'

import { ReactInvoiceRenderer } from '@sequencehq/invoice-content'

import { useInvoiceRendererData } from './useInvoiceRendererData'

type Props = {
  width: number
  showSkeletons: boolean
}

export const InvoiceRenderer: FC<Props> = ({ width, showSkeletons }) => {
  const rendererData = useInvoiceRendererData()

  return (
    <ReactInvoiceRenderer
      data={rendererData}
      theme="DEFAULT"
      width={width}
      showSkeletons={showSkeletons}
    />
  )
}
